import { useMsal } from "@azure/msal-react";
import React from "react"

const SessionExpired = () => {

	const context = useMsal();

	const handleSignOut = (e) => {
		const isInIframe = window.parent !== window.self;
		const iframeParentOrigin = isInIframe ? document.referrer : "";
		const isAccessedFromRuntime = isInIframe && iframeParentOrigin === (process.env.REACT_APP_RUNTIME_URL + "/");
		if (isAccessedFromRuntime) {	
			localStorage.clear();
			window.parent.postMessage(JSON.stringify({
				designerStatus: "Signout",
			}), process.env.REACT_APP_RUNTIME_URL);
		} else {
			localStorage.clear();
			context.instance.logoutRedirect();
		}
	}

	return (
		<div class="d-flex flex-column min-vh-100 justify-content-center align-items-center bg-primary">
			<div class="card bg-white shadow-lg">
				<div class="card-body text-center p-5">
					<img
						src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/Signout.png`}
						alt="session expired"
						width={150}
						className="img-fluid"
					/>
					<h3 className="text-muted pt-3">Your session has expired</h3>
					<p className="text-secondary py-3">
						Please log in again to continue using the application
					</p>
					<button className="btn btn-primary" onClick={handleSignOut}>Sign out</button>
				</div>
			</div>
		</div>
	)
}

export default SessionExpired
